import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface FetchReimbursementsListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  schemeType?: string;
  isPending?: boolean;
}

export interface ReimbursementsListElement {
  applicant_id: number;
  vat_number: string;
  is_sent: boolean;
  type: string;
  reminded_date: Date;
}

export interface ReimbursementsListData {
  paging: ReimbursementsListPaging;
  items: ReimbursementsListElement[];
}

export interface ReimbursementsListPaging {
  page: number;
  pageSize: number;
  total: number;
}

export const fetchReimbursementsList = async (
  payload: FetchReimbursementsListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.schemeType) searchQuery += `&schemeType=${payload.schemeType}`;
  if (payload.isPending) searchQuery += `&isPending=${payload.isPending}`;
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/reimbursement/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: ReimbursementsListData = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface UpdateReimburseInfoInput {
  reimburse_info_msid_id: number;
  iban: string;
  bic: string;
  vat_amount_to_be_reimbursed: number;
  date_reimbursed: Date;
  searchParams: any;
}

export const UpdateReimburseInfo = async (
  payload: UpdateReimburseInfoInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/reimbursement/update-info`,
    {
      reimburse_info_msid_id: payload.reimburse_info_msid_id,
      iban: payload.iban,
      bic: payload.bic,
      vat_amount_reimbursed: payload.vat_amount_to_be_reimbursed,
      date_reimbursed: payload.date_reimbursed,
    }
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };

  return output;
};
